import axios from 'axios'

const frontendAPI = {
    // Auth
    getHomepageData() {
        return new Promise((resolve, reject) => {
            axios.get('/guest/home').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getSearchRoomResult(data) {
        return new Promise((resolve, reject) => {
            axios.post('/guest/room-search', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    /*getRoomDetails(id) {
        return new Promise((resolve, reject) => {
            axios.get('/guest/room-details/' + id).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },*/

    getProductDetails(data) {
        return new Promise((resolve, reject) => {
            axios.post('/guest/product-details', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getBlogs(data) {
        return new Promise((resolve, reject) => {
            axios.post('/guest/get-blogs', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getBlogDetails(blog_slug,category_slug) {
        return new Promise((resolve, reject) => {
            axios.get('/guest/blog-details/' + category_slug+'/'+blog_slug).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    activeCategory() {
        return new Promise((resolve, reject) => {
            axios.get('/guest/active-categories').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getPaymentOptions() {
        return new Promise((resolve, reject) => {
            axios.get('/guest/active-payment-options').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
     //get product features
     getProductFeatures() {
        return new Promise((resolve, reject) => {
            axios.get('/guest/active-product-features').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    //get handler brandnames
    getHandlerBrandNames() {
        return new Promise((resolve, reject) => {
            axios.get('/guest/producer-brandName-list').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    //get product certificates
    getProductCertificates() {
        return new Promise((resolve, reject) => {
            axios.get('/guest/active-certifications').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getStates() {
        return new Promise((resolve, reject) => {
            axios.get('/guest/active-states').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getProductUnits() {
        return new Promise((resolve, reject) => {
            axios.get('/guest/active-units').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getDeliveryOptions() {
        return new Promise((resolve, reject) => {
            axios.get('/guest/active-delivery-options').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getAboutContent() {
        return new Promise((resolve, reject) => {
            axios.get('/guest/get-about-us').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    bookTheRoom(data) {
        return new Promise((resolve, reject) => {
            axios.post('/customer/room-book', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    addHandlerToWishlist(data) {
        return new Promise((resolve, reject) => {
            axios.post('/customer/add-producer-wishlist', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getHandlerWishlist(data) {
        return new Promise((resolve, reject) => {
            axios.post('/customer/get-producer-wishlist', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    addSpecialRequest(data){
        return new Promise((resolve, reject) => {
            axios.post('/guest/add-special-request', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getActiveBadges() {
        return new Promise((resolve, reject) => {
            axios.get('/guest/active-badges').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getUserType(data){
        return new Promise((resolve, reject) => {
            axios.get('/get-user-role/' + data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getProductsListing(data){
        let config = {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': 'true',
            'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
            'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
          }
        };
        return new Promise((resolve, reject) => {
            axios.post('/guest/product-list', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getDealersListing(data){
        return new Promise((resolve, reject) => {
            axios.post('/guest/producer-list', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getHandlerDetails(data) {
        return new Promise((resolve, reject) => {
            axios.get('/guest/producer-details/' + data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    addToWishlist(data) {
        return new Promise((resolve, reject) => {
            axios.post('/customer/add-product-wishlist', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getWishlist(data) {
        return new Promise((resolve, reject) => {
            axios.post('/customer/get-product-wishlist', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    updateProductViews(data) {
        return new Promise((resolve, reject) => {
            axios.post('/guest/product-view', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getActiveBlogCategories() {
        return new Promise((resolve, reject) => {
            axios.get('/guest/active-blog-categories').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getCategoryBlogs(data) {
        return new Promise((resolve, reject) => {
            axios.post('/guest/category-blogs', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // Cart
    getCartProductDetails(data) {
        return new Promise((resolve, reject) => {
            axios.post('/guest/get-cart-items', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    applyCouponCode(data) {
        return new Promise((resolve, reject) => {
            axios.post('/guest/apply_discount_coupon', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    makeCardPayment(data) {
        return new Promise((resolve, reject) => {
            axios.post('/guest/make-card-payment', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    addNewsletter(data) {
        return new Promise((resolve, reject) => {
            axios.post('/guest/add-newsletter', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    unsubscribeNewsletter(data) {
        return new Promise((resolve, reject) => {
            axios.post('/guest/unsubscribe-newsletter', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getStripeAPIKeys(id) {
        return new Promise((resolve, reject) => {
            axios.post('/guest/get-stripe-keys/' + id).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    createPaymentIntent(data) {
        return new Promise((resolve, reject) => {
            axios.post('/guest/create-payment-intent', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getPaypalRedirectUrl(data) {
        return new Promise((resolve, reject) => {
            axios.post('/guest/paypal-redirect-url', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getMollieRedirectUrl(data) {
        return new Promise((resolve, reject) => {
            axios.post('/guest/mollie-redirect-url', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    generatePaypalOrder(data) {
        return new Promise((resolve, reject) => {
            axios.post('/guest/generate-order', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    confirmEmail(email) {
        return new Promise((resolve, reject) => {
            axios.get('/guest/change-status/' + email).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
}

export default frontendAPI
